import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { AuthenticFormVM } from 'front-office/view-models/authentic/authentic-form';
import { useFormikContext } from 'formik';
import PaymentCertificate from 'front-office/components/shared/payment';
import AuthenticAnpr from './authentic';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalCertificateProps {
  open: boolean;
  onClose: (open: boolean) => void;
}

const ModalCertificate = ({ open, onClose }: ModalCertificateProps): React.ReactElement => {
  const formContext = useFormikContext<AuthenticFormVM>();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Richiesta Autentica
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <AuthenticAnpr />
        <PaymentCertificate />
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="button"
          onClick={() => formContext.handleSubmit()}
        >
          Richiesta Autentica
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalCertificate.displayName = 'Modal request certificate';

export default ModalCertificate;
